export default "__VITE_ASSET__CHcHjgZv__"